import React, { useContext, useEffect, useState } from "react";
import { Button, Flex, CaretUp, CaretDown, Input, Heading, TextArea, Select, Text, Checkbox, MRadio, Trash, Card, Plus, XCircle } from "@cisco/spaces-dash-lib-styleguide";
import { useNotification } from "@cisco/spaces-dash-app-business-hierarchy";
import UseCaseEmptyIcon from "../../../assets/images/partner/usecases-empty.svg";
import DefaultUseCaseConfig from "../default-usecase.json";
import { I18nContext } from "../../../contexts/i18nContext";
import "./usecase-tab.scss";
import ImageUpload from "../image-upload/image-upload";

function UseCaseTab(props) {
  const { app, action, setApp, technologyFilter, useCaseCategories } = props;
  const { setToastMessage } = useNotification();
  const i18n = useContext(I18nContext);
  const [showEmptyState, setShowEmptyState] = useState(true);
  const [accordionIndex, setAccordionIndex] = useState(0);

  const [filePath, setFilePath] = useState("");

  const people = [
    {
      value: "employee",
      label: i18n.t("partner-dashboard-app.partner-apps.partner-use-case.employee-text")
    },
    {
      value: "visitor",
      label: i18n.t("partner-dashboard-app.partner-apps.partner-use-case.visitors-text")
    },
    {
      value: "others",
      label: i18n.t("partner-dashboard-app.partner-apps.partner-use-case.others-text")
    }
  ];

  const things = [
    {
      value: "movable",
      label: i18n.t("partner-dashboard-app.partner-apps.partner-use-case.moveable-assets-text")
    },
    {
      value: "fixed",
      label: i18n.t("partner-dashboard-app.partner-apps.partner-use-case.fixed-assets-text")
    }
  ];

  const businessValues = [
    i18n.t("partner-dashboard-app.partner-apps.partner-use-case.op-efficiency-text"),
    i18n.t("partner-dashboard-app.partner-apps.partner-use-case.increased-revenue-text"),
    i18n.t("partner-dashboard-app.partner-apps.partner-use-case.increased-customer-satisfaction-text"),
    i18n.t("partner-dashboard-app.partner-apps.partner-use-case.average-cost-text")
  ];

  const handleInput = (event, field, index) => {
    const newEditingNode = { ...app };
    if (newEditingNode.useCases[index][field]) {
      newEditingNode.useCases[index][field] = event.target.value;
    } else {
      newEditingNode.useCases[index][field] = "";
      newEditingNode.useCases[index][field] = event.target.value;
    }
    setApp(newEditingNode);
  };

  useEffect(() => {
    console.log("UseCasesTab Mount");
    if (app.useCases && app.useCases.length) {
      setShowEmptyState(false);
    }
    if (app.appId) {
      const fPath = `usecase/${sessionStorage.getItem("tenantId")}/${app.appId}`;
      setFilePath(fPath);
    }
    return () => {
      console.log("UseCasesTab Destroy");
    };
  }, []);

  const addNewUseCase = () => {
    const newEditingNode = { ...app };
    const DefaultUseCaseConfigCopy = JSON.parse(JSON.stringify(DefaultUseCaseConfig));
    DefaultUseCaseConfigCopy.otherCategory = "";
    const firstCategory = {
      type: useCaseCategories[0].value,
      subCategories: useCaseCategories[0].subCategories
    };
    DefaultUseCaseConfigCopy.categories = firstCategory;
    if (newEditingNode.useCases && newEditingNode.useCases.length) {
      newEditingNode.useCases.push(DefaultUseCaseConfigCopy);
      setAccordionIndex(newEditingNode.useCases.length - 1);
    } else {
      newEditingNode.useCases = [];
      newEditingNode.useCases.push(DefaultUseCaseConfigCopy);
      setShowEmptyState(false);
    }
    setApp(newEditingNode);
  };

  const onClickCheckbox = (field, type, i, index) => {
    const newEditingNode = { ...app };
    if (newEditingNode.useCases[index] && newEditingNode.useCases[index].applicable && newEditingNode.useCases[index].applicable[field]) {
      newEditingNode.useCases[index].applicable[field][type] = !newEditingNode.useCases[index].applicable[field][type];
    }
    setApp(newEditingNode);
  };

  const checkboxTemplate = (field, type, i, index) => {
    return (
      <Checkbox key={i} onClick={() => onClickCheckbox(field, type?.value, i, index)} checked={app.useCases[index].applicable[field][type?.value]}>
        {type.label}
      </Checkbox>
    );
  };

  const onClickCheckboxBusiness = (type, i, index) => {
    const newEditingNode = { ...app };
    if (newEditingNode.useCases[index] && newEditingNode.useCases[index].businessValue) {
      if (newEditingNode.useCases[index].businessValue?.indexOf(type) > -1) {
        const ind = newEditingNode.useCases[index].businessValue.indexOf(type);
        newEditingNode.useCases[index].businessValue.splice(ind, 1);
      } else {
        newEditingNode.useCases[index].businessValue.push(type);
      }
    } else {
      newEditingNode.useCases[index].businessValue = [];
      newEditingNode.useCases[index].businessValue.push(type);
    }
    setApp(newEditingNode);
  };

  const checkboxBusinessTemplate = (type, i, index) => {
    return (
      <Checkbox key={i} onClick={() => onClickCheckboxBusiness(type, i, index)} checked={app.useCases[index].businessValue?.indexOf(type) > -1}>
        {type}
      </Checkbox>
    );
  };

  const onChangeTechType = (label, index, reqType) => {
    const newEditingNode = { ...app };
    if (!newEditingNode.useCases[index].technology) {
      newEditingNode.useCases[index].technology = {};
    }
    if (!newEditingNode.useCases[index].technology[reqType]) {
      newEditingNode.useCases[index].technology[reqType] = [];
    }
    if (newEditingNode.useCases[index] && newEditingNode.useCases[index].technology) {
      const techList = newEditingNode.useCases[index].technology[reqType];
      if (techList.indexOf(label) > -1) {
        const techIndex = techList.indexOf(label);
        techList.splice(techIndex, 1);
      } else {
        const allTypes = ["required", "nicetohave", "doesnotuse"];
        allTypes.forEach((t) => {
          if (t === reqType) {
            techList.push(label);
          } else {
            const otherTypeList = newEditingNode.useCases[index].technology[t];
            if (otherTypeList && otherTypeList.length) {
              const techIndex = otherTypeList.indexOf(label);
              if (techIndex > -1) {
                otherTypeList.splice(techIndex, 1);
              }
            }
          }
        });
      }
    }
    setApp(newEditingNode);
  };

  const technologiesTemplate = (tech, i, index) => {
    return (
      <div className="tech" key={index}>
        <div className="techName">{tech.label}</div>
        <div>
          <MRadio
            direction="horizontal"
            onChange={() => {
              onChangeTechType(tech.label, index, "required");
            }}
            value={app.useCases[index].technology?.required?.indexOf(tech.label) > -1}
            options={[
              {
                key: 1,
                value: true
              }
            ]}
            size="md"
          />
        </div>
        <div>
          <MRadio
            direction="horizontal"
            onChange={() => {
              onChangeTechType(tech.label, index, "nicetohave");
            }}
            value={app.useCases[index].technology?.nicetohave?.indexOf(tech.label) > -1}
            options={[
              {
                key: 1,
                value: true
              }
            ]}
            size="md"
          />
        </div>
        <div>
          <MRadio
            direction="horizontal"
            onChange={() => {
              onChangeTechType(tech.label, index, "doesnotuse");
            }}
            value={app.useCases[index].technology?.doesnotuse?.indexOf(tech.label) > -1}
            options={[
              {
                key: 1,
                value: true
              }
            ]}
            size="md"
          />
        </div>
      </div>
    );
  };

  const showInvalidImageMsg = () => {
    setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-center.upload-proper-image-msg"), 4000, "negative");
  };

  const saveImagePath = (path, type, name, index) => {
    if (type == "icon") {
      handleInput({ target: { value: name } }, "appIcon", index);
      handleInput({ target: { value: path } }, "appIconS3Url", index);
    } else if (type == "image") {
      const obj = {
        imgIcon: name,
        imgIconS3Url: path
      };
      const newEditingNode = { ...app };
      if (newEditingNode.useCases[index].appMedia) {
        if (newEditingNode.useCases[index].appMedia.image) {
          newEditingNode.useCases[index].appMedia.image.push(obj);
        } else {
          newEditingNode.useCases[index].appMedia.image = [];
          newEditingNode.useCases[index].appMedia.image.push(obj);
        }
      } else {
        newEditingNode.useCases[index].appMedia = {};
        newEditingNode.useCases[index].appMedia.image = [];
        newEditingNode.useCases[index].appMedia.image.push(obj);
      }
      setApp(newEditingNode);
    }
  };

  const removeScreenshot = (index, ind) => {
    const newEditingNode = { ...app };
    if (newEditingNode.useCases[index].appMedia.image.length) {
      newEditingNode.useCases[index].appMedia.image.splice(ind, 1);
    }
    setApp(newEditingNode);
  };

  const appMediaImageTemplate = (index, ind) => {
    return (
      <div key={index} className="imgContainer">
        <img className="icon-image" src={app.useCases[index].appMedia.image[ind].imgIconS3Url} alt="Usecase Media" />
        <div className="imgRemoveBtn">
          <Button kind="tertiary" onClick={() => removeScreenshot(index, ind)}>
            {i18n.t("partner-dashboard-app.partner-apps.app-settings.remove-text")}
          </Button>
        </div>
      </div>
    );
  };

  // const appMediaImageTemplate = (src, index) => {
  //   return (
  //     <div key={index} className="imgContainer">
  //       <img className="icon-image" src={src.imgIconS3Url} alt="Usecase Media" width={100} />
  //     </div>
  //   );
  // };

  const handleYoutubeInput = (event, index) => {
    const newEditingNode = { ...app };
    if (newEditingNode.useCases[index].appMedia && newEditingNode.useCases[index].appMedia.video) {
      newEditingNode.useCases[index].appMedia.video = [];
      newEditingNode.useCases[index].appMedia.video.push({ url: event.target.value });
    } else {
      newEditingNode.useCases[index].appMedia = {};
      newEditingNode.useCases[index].appMedia.video = [];
      newEditingNode.useCases[index].appMedia.video.push({ url: event.target.value });
    }
    setApp(newEditingNode);
  };

  const getVideoUrl = (url) => {
    if (url) {
      let ytId = "";
      if (url.includes("youtu.be")) {
        [, ytId] = url.split("youtu.be/");
      } else if (url.includes("youtube.com")) {
        [, ytId] = url.split("v=");
        const andPos = ytId.indexOf("&");
        if (andPos != -1) {
          ytId = ytId.substring(0, andPos);
        }
      }
      return ytId;
    }
    return "";
  };

  const onClickCategory = (val, index) => {
    const newEditingNode = { ...app };
    if (val && newEditingNode.useCases[index] && newEditingNode.useCases[index].categories) {
      newEditingNode.useCases[index].categories.type = val;
    } else {
      newEditingNode.useCases[index].categories = {
        type: val,
        subCategories: []
      };
    }
    useCaseCategories.forEach((category) => {
      if (category.value === val) {
        newEditingNode.useCases[index].categories.subCategories = [...category.subCategories];
      }
    });
    setApp(newEditingNode);
  };

  const removeSubCat = (i, index) => {
    const newEditingNode = { ...app };
    if (
      newEditingNode.useCases[index] &&
      newEditingNode.useCases[index].categories &&
      newEditingNode.useCases[index].categories.subCategories &&
      newEditingNode.useCases[index].categories.subCategories.length
    ) {
      newEditingNode.useCases[index].categories.subCategories.splice(i, 1);
    }
    setApp(newEditingNode);
  };

  const subCategoriesTemplate = (category, i, index) => {
    return (
      <span className="chipLabel" key={index}>
        <span className="chipName">{category.name}</span>
        <span
          className="chipClose"
          tabIndex={-1}
          role="button"
          onKeyDown={() => {
            removeSubCat(i, index);
          }}
          onClick={() => {
            removeSubCat(i, index);
          }}
          aria-label="chipClose"
        >
          <XCircle />
        </span>
      </span>
    );
  };

  const deleteUseCase = (i) => {
    const newEditingNode = { ...app };
    newEditingNode.useCases.splice(i, 1);
    if (newEditingNode.useCases.length === 0) {
      setShowEmptyState(true);
    }
    setApp(newEditingNode);
  };

  const toggleAccordionIndex = (index) => {
    if (accordionIndex === index) {
      setAccordionIndex(null);
    } else {
      setAccordionIndex(index);
    }
  };

  const useCaseTemplate = (usecase, index) => {
    return (
      <Flex key={index} direction="vertical" gap={16}>
        <Card key={index} style={{ "margin-bottom": "30px", position: "relative" }}>
          <Flex direction="vertical" gap={12}>
            <Flex align="flex-start" style={{ cursor: "pointer" }} onClick={() => toggleAccordionIndex(index)} direction="horizontal" justify="space-between">
              <Flex direction="vertical" gap={2}>
                <Heading size="sub-section">
                  {i18n.t("partner-dashboard-app.partner-apps.partner-use-case.use-case-text")}
                  {index + 1}
                </Heading>
              </Flex>
              <Flex gap={8}>
                {accordionIndex === index ? (
                  <Button kind="tertiary">
                    <CaretUp onClick={() => toggleAccordionIndex(index)} />
                  </Button>
                ) : (
                  <Button kind="tertiary">
                    <CaretDown onClick={() => toggleAccordionIndex(index)} />
                  </Button>
                )}
              </Flex>
            </Flex>
            {accordionIndex === index ? (
              <div className="useCaseForm">
                <span className="useCaseDelete">
                  <Button disabled={action === "view"} kind="secondary">
                    <Trash onClick={() => deleteUseCase(index)} />
                  </Button>
                </span>
                <Flex direction="vertical" gap={8}>
                  <div key={index}>
                    <div className="leftLayout">
                      <Flex direction="vertical" gap={16}>
                        <Flex direction="vertical" gap={8}>
                          <Heading size="sub-section">{i18n.t("partner-dashboard-app.partner-apps.end-devices.end-device-config.fields-marked-mandatory-text")}</Heading>
                        </Flex>
                        <Flex className="formMaxWidth" direction="vertical" gap={8}>
                          <Input
                            size="md"
                            onChange={(e) => {
                              handleInput(e, "headLine", index);
                            }}
                            value={app.useCases[index].headLine}
                            label={i18n.t("partner-dashboard-app.partner-apps.partner-use-case.use-case-headline-text")}
                            required
                            placeholder={i18n.t("partner-dashboard-app.placeholders.add-title-text")}
                          />
                        </Flex>
                        <Flex className="formMaxWidth" direction="vertical" gap={8}>
                          <Text className="mds-rebuild-input-size-md" style={{ "font-weight": "600" }}>
                            {i18n.t("partner-dashboard-app.partner-apps.partner-use-case.use-case-icon-text")}
                            <span className="mds-rebuild-input-label-required">*</span>
                          </Text>
                          <Flex gap={2}>
                            {app?.useCases[index] && app?.useCases[index].appIconS3Url ? (
                              <img className="icon-image" src={app.useCases[index].appIconS3Url} alt={`${app.useCases[index].appIconS3Url} Icon`} width={100} />
                            ) : (
                              ""
                            )}
                          </Flex>
                        </Flex>
                        <Flex className="formMaxWidth" direction="vertical" gap={2}>
                          <ImageUpload fileId="usecaseIcon" path={`${filePath}/${index}`} type="icon" showInvalidImageMsg={showInvalidImageMsg} saveImagePath={saveImagePath} index={index} />
                        </Flex>
                        <Flex className="formMaxWidth" direction="vertical" gap={8}>
                          <TextArea
                            onChange={(e) => {
                              handleInput(e, "description", index);
                            }}
                            value={app.useCases[index].description}
                            label={i18n.t("partner-dashboard-app.partner-apps.partner-use-case.use-case-description-text")}
                            required
                            placeholder={i18n.t("partner-dashboard-app.placeholders.add-short-description-text")}
                          />
                        </Flex>
                        <Flex className="formMaxWidth" direction="vertical" gap={8}>
                          <TextArea
                            onChange={(e) => {
                              handleInput(e, "fullDescription", index);
                            }}
                            value={app.useCases[index].fullDescription}
                            label={i18n.t("partner-dashboard-app.partner-apps.partner-use-case.use-case-long-description-text")}
                            placeholder={i18n.t("partner-dashboard-app.placeholders.add-long-description-text")}
                          />
                        </Flex>
                        <Flex className="formMaxWidth" direction="vertical" gap={8}>
                          <TextArea
                            onChange={(e) => {
                              handleInput(e, "compatibilityNotes", index);
                            }}
                            value={app.useCases[index].compatibilityNotes}
                            label={i18n.t("partner-dashboard-app.partner-apps.partner-use-case.compatibility-notes-text")}
                            placeholder={i18n.t("partner-dashboard-app.placeholders.compatibility-notes-text")}
                          />
                        </Flex>
                        <Flex className="formMaxWidth" direction="vertical" gap={8}>
                          {useCaseCategories && useCaseCategories.length && (
                            <div>
                              <Text className="mds-rebuild-input-size-md" style={{ "font-weight": "600" }}>
                                {i18n.t("partner-dashboard-app.partner-apps.partner-use-case.use-case-category-text")} <span className="mds-rebuild-input-label-required">*</span>
                              </Text>
                              <Select
                                onChange={(e) => {
                                  onClickCategory(e, index);
                                }}
                                options={useCaseCategories}
                                placeholder={i18n.t("partner-dashboard-app.partner-apps.partner-use-case.use-case-category-text")}
                                value={app.useCases[index].categories?.type}
                              />
                            </div>
                          )}
                          {app.useCases[index].categories?.type === "others" && app.useCases[index].otherCategory && (
                            <Flex className="formMaxWidth" direction="vertical" gap={8}>
                              <Text className="mds-rebuild-input-size-md" style={{ "font-weight": "600" }}>
                                {i18n.t("partner-dashboard-app.partner-apps.partner-use-case.other-use-case-category-text")}
                              </Text>
                              <Input
                                size="md"
                                onChange={(e) => {
                                  handleInput(e, "otherCategory", index);
                                }}
                                value={app.useCases[index].otherCategory}
                                label={i18n.t("partner-dashboard-app.partner-apps.partner-use-case.other-use-case-category-text")}
                                placeholder={i18n.t("partner-dashboard-app.placeholders.enter-other-category-text")}
                              />
                            </Flex>
                          )}
                        </Flex>
                        <Flex gap={8}>
                          <div>
                            <Text className="mds-rebuild-input-size-md" style={{ "font-weight": "600" }}>
                              {i18n.t("partner-dashboard-app.partner-apps.partner-use-case.use-case-sub-category-text")}
                            </Text>
                            <div className="subCategoryList">
                              {app.useCases[index].categories && app.useCases[index].categories.subCategories && app.useCases[index].categories.subCategories.length
                                ? app.useCases[index].categories.subCategories.map((category, i) => subCategoriesTemplate(category, i, index))
                                : ""}
                            </div>
                          </div>
                        </Flex>
                        <Flex direction="vertical" gap={8}>
                          <Heading size="sub-section">{i18n.t("partner-dashboard-app.partner-apps.partner-use-case.who-is-this-use-case-applicable-text")}</Heading>
                          <Flex direction="vertical" gap={8}>
                            <Text className="mds-rebuild-input-size-md">{i18n.t("partner-dashboard-app.partner-apps.customer-app-usecase.people-text")}</Text>
                            <Flex wrap className="formMaxWidth2" direction="horizontal" gap={24}>
                              {people && people.map((type, i) => checkboxTemplate("people", type, i, index))}
                            </Flex>
                          </Flex>
                          <Flex direction="vertical" gap={8} style={{ "margin-top": "20px" }}>
                            <Text className="mds-rebuild-input-size-md">{i18n.t("partner-dashboard-app.partner-apps.customer-app-usecase.things-text")}</Text>
                            <Flex wrap className="formMaxWidth2" direction="horizontal" gap={24}>
                              {things && things.map((type, i) => checkboxTemplate("things", type, i, index))}
                            </Flex>
                          </Flex>
                          <Flex direction="vertical" gap={8} style={{ "margin-top": "20px" }}>
                            <Heading size="sub-section">{i18n.t("partner-dashboard-app.partner-apps.partner-use-case.what-value-drive-for-customer-text")}</Heading>
                            <Flex direction="vertical" gap={8}>
                              <Flex wrap className="formMaxWidth2" direction="horizontal" gap={24}>
                                {businessValues && businessValues.map((type, i) => checkboxBusinessTemplate(type, i, index))}
                              </Flex>
                            </Flex>
                          </Flex>
                          <Flex direction="vertical" gap={8} style={{ "margin-top": "30px" }}>
                            <Heading size="sub-section">{i18n.t("partner-dashboard-app.partner-apps.partner-use-case.infrastructure-compatibility-text")}</Heading>
                            <Flex direction="vertical" gap={8}>
                              <div className="techTable">
                                <div className="techHeadings">
                                  <div>{i18n.t("partner-dashboard-app.partner-apps.partner-use-case.infrastructure-text")}</div>
                                  <div>{i18n.t("partner-dashboard-app.partner-apps.partner-use-case.required-text")}</div>
                                  <div>{i18n.t("partner-dashboard-app.partner-apps.partner-use-case.nice-to-have-text")}</div>
                                  <div>{i18n.t("partner-dashboard-app.partner-apps.partner-use-case.does-not-use-text")}</div>
                                </div>
                                {technologyFilter && technologyFilter.length && technologyFilter.map((tech, i) => technologiesTemplate(tech, i, index))}
                              </div>
                            </Flex>
                          </Flex>
                        </Flex>
                      </Flex>
                    </div>
                    <div className="rightLayout">
                      <Flex direction="vertical" gap={16}>
                        <Flex direction="vertical" gap={8}>
                          <div>{i18n.t("partner-dashboard-app.partner-apps.customer-app-usecase.screen-shots-text")}</div>
                          <div>{i18n.t("partner-dashboard-app.partner-apps.partner-app-center.suggested-size-text")}: 1240x720px</div>
                        </Flex>
                        <Flex direction="vertical" gap={4}>
                          <ImageUpload fileId="usecaseMedia" path={filePath} type="image" showInvalidImageMsg={showInvalidImageMsg} saveImagePath={saveImagePath} index={index} />
                        </Flex>
                        <Flex direction="vertical" gap={4}>
                          {app.useCases[index].appMedia && app.useCases[index].appMedia.image && app.useCases[index].appMedia.image.length
                            ? app.useCases[index].appMedia.image.map((img, ind) => appMediaImageTemplate(index, ind))
                            : ""}
                        </Flex>
                        <Flex direction="vertical" gap={8} />
                        <Flex direction="vertical" gap={8}>
                          <Input
                            size="md"
                            onChange={(e) => {
                              handleYoutubeInput(e, index);
                            }}
                            value={app.useCases[index].appMedia?.video?.[0]?.url}
                            label={i18n.t("partner-dashboard-app.placeholders.you-tube-video-url")}
                            placeholder={i18n.t("partner-dashboard-app.placeholders.you-tube-video-url")}
                          />
                        </Flex>
                        <Flex direction="vertical" gap={8}>
                          <iframe
                            style={{
                              width: "100%",
                              height: "315px"
                            }}
                            title="usecase_video"
                            src={`//www.youtube.com/embed/${getVideoUrl(app.useCases[index].appMedia?.video?.[0]?.url)}`}
                          />
                        </Flex>
                      </Flex>
                    </div>
                  </div>
                </Flex>
              </div>
            ) : (
              ""
            )}
          </Flex>
        </Card>
      </Flex>
    );
  };

  return (
    <div className="pBottom40">
      {showEmptyState && (
        <div className="textCenter">
          <Flex align="center" direction="vertical" gap={12}>
            <Flex align="center" direction="vertical" gap={8}>
              <img width="200" src={UseCaseEmptyIcon} alt="UseCaseEmptyIcon" />
            </Flex>
            <Flex direction="vertical" gap={8}>
              <Heading style={{ "font-size": "24px" }}>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.no-usecase-added-text")}</Heading>
            </Flex>
            <Flex direction="vertical" gap={4}>
              <Text color="light">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.have-not-added-any-usecase-text")}</Text>
              <Text color="light">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.please-add-usecase-text")}</Text>
            </Flex>
            <Flex align="center" direction="vertical" gap={8}>
              <div className="textCenter addButtonContainer">
                <Button disabled={action === "view"} onClick={addNewUseCase}>
                  {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.add-use-case-text")}
                </Button>
              </div>
            </Flex>
          </Flex>
        </div>
      )}
      {!showEmptyState && app.useCases.length ? app.useCases.map((usecase, index) => useCaseTemplate(usecase, index)) : ""}
      {!showEmptyState && app.useCases.length ? (
        <Flex direction="vertical" gap={16}>
          <div style={{ margin: "20px 0" }} className="addAnotherButtonContainer">
            <Button disabled={action === "view"} kind="secondary" onClick={addNewUseCase}>
              <Plus />
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.add-another-usecase-text")}
            </Button>
          </div>
        </Flex>
      ) : (
        ""
      )}
    </div>
  );
}

export default UseCaseTab;
